import React, { Component } from "react";
import HOC from "./HOC";
import { Auth } from "aws-amplify";
import Utils from "../utils/Validate";
import { obtenerMetodosPago } from "../../service/actions";
import Breadcrumb from "../components/comunes/Breadcrumb";
import {
  CONSTANTES,
  LISTA_TIPO_OPERACIONES,
  LISTA_TIPO_OPERACIONES_FLEXIVIDA,
  LISTA_OPERACION_COB,
  LISTA_OPERACION_COB_VIDA
} from "../utils/Constantes";
import circleleft from "../resource/img/circlechevrot-left.svg";
import ccardVisa from "../resource/img/ccard-visa.svg";
import ccardAmex from "../resource/img/ccard-amex.svg";
import ccardDinner from "../resource/img/ccard-dinner.svg";
import ccardMaster from "../resource/img/ccard-master.svg";
import personajes from "../resource/img/pages/metodos_pago/personajes.svg";
import personajestyp from "../resource/img/pages/metodos_pago/personajestyp.svg";
// import Modal from "../components/comunes/Modal";
import ModalGenerico from "../components/comunes/ModalGenerico";
import DocumentosPago from "../components/DocumentosPago";
import CustomDropDown from "../components/formulario/Dropdown";
import "../resource/css/metodosPago.css";
import "../resource/css/skeleton.css";
import M from "materialize-css";

class MetodosPago extends Component {
  state = {
    showMetpagos: false,
    showPolizaExistente: false,
    showNumPoliza: false,
    metpagosLoader: false,
    tipoDocumento: "2",
    nroDocumento: "",
    textTipoDocumento: "",
    inputMax: "8",
    inputValid: true,
    payments: "",
    cardselected: false,
    successafil: false,
    //state Afiliacion
    mostrarModal: false,
    mostrarModalDocumentosPago: false,
    isLoading: false,
    m_modal: "",
    casoModal: "",
    pagination: 10,
    pages: 0,
    page: 0,
    filtered: [],
    open: false,
    showBusqueda: "None",
    disableDiv: false,
    disabledMonto: false,
    showDocumentoCobro: "None",
    idremesa: "",
    //Agregando Nuevo
    //tipo:'',
    tipoTab1: "",
    tipoTab2: "",
    pagoFacil: "",
    codigoProductoTab1: "", // del texto
    codigoProductoTab2: "", // del texto
    disabledCodProducto: false,
    disabledMoneda: false,
    producto: "", // del combo
    productoTab1: "", // del combo
    productoTab2: "", // del combo
    polizaTab1: "",
    polizaTab2: "",
    disabledNumPoliza: false,
    documento: "",
    documentos: "",
    documentoMonto: "",
    fecVenDoc: "",
    tipoDocumentoCob: "",
    // tipoDocumento: '',
    documentoCobro: "",
    numIdTercero: "",
    disabledNumdoc: false,
    disabledTipoDoc: false,
    disabledEnviar: false,
    aseguradoNombre: "",
    aseguradoApellidoPat: "",
    aseguradoApellidoMat: "",
    tipoOperacionCobTab1: "",
    tipoOperacionCobTab2: "",
    tipoTarjeta: "NUEVA TARJETA",
    //Ini - M.315456.01
    //tipoOperacionTab1: "",
    //Fin - M.315456.01
    tipoOperacionTab2: "",
    codigoTarjeta: "",
    numCuotasTab1: "",
    numCuotasTab2: "",
    emailAsesor: "",
    //emailCliente: '',
    //Ini - M.315456.01
    //emailClienteTab1: "",
    //Fin - M.315456.01
    emailClienteTab2: "",
    moneda: "",
    monedaTab1: "",
    monedaTab2: "",
    total: "",
    totalTab1: "",
    totalTab2: "",
    usuario: "",
    //disabledCuota:true,
    disabledCuotaTab1: true,
    disabledCuotaTab2: true,
    v_pagoFacil: "",
    v_nroDocumentoCobro: "",
    v_poliza: "",
    v_tipoDocumento: "",
    v_nroDocumento: "",
    v_aseguradoNombre: "",
    v_aseguradoApellidoPat: "",
    v_aseguradoApellidoMat: "",
    v_producto: "",
    v_tipoOperacionCob: "",
    v_tipoOperacion: "",
    v_numCuotas: "",
    v_emailAsesor: "",
    v_emailCliente: "",
    v_moneda: "",
    v_total: "",
    v_codigoProducto: "",
    v_documentoCombro: "",
    lstTarjeta: [
      {
        name: "tipoTarjeta",
        value: "2",
        detalle: "NUEVA TARJETA",
        checked: true,
      },
    ],
    listaTipoDocumentos: [
      {
        value: "2",
        detalle: "DNI",
      },
      {
        value: "4",
        detalle: "C.E.",
      },
      {
        value: "6",
        detalle: "PASAPORTE",
      },
    ],
    listaProducto: [
      {
        id: "VE",
        text: "Vehicular",
      },
      {
        id: "RG",
        text: "Riesgos Generales",
      },
      {
        id: "VIDA",
        text: "Vida",
      },
      {
        id: "SD",
        text: "Salud",
      },
    ],
    listaOperacionCob: [
      {
        id: "CVC",
        text: "Cambio de medio de pago",
      },
      {
        id: "FIN",
        text: "Financiamiento",
      },
    ],
    listaOperacion2: LISTA_TIPO_OPERACIONES,
    listaOperacion1: [
      {
        id: "SUSCRIPCION",
        text: "Suscripción",
      },
    ],
    listaCuotas: [
      {
        id: "1",
        text: "01",
      },
      {
        id: "2",
        text: "02",
      },
      {
        id: "3",
        text: "03",
      },
      {
        id: "4",
        text: "04",
      },
      {
        id: "5",
        text: "05",
      },
      {
        id: "6",
        text: "06",
      },
      {
        id: "7",
        text: "07",
      },
      {
        id: "8",
        text: "08",
      },
      {
        id: "9",
        text: "09",
      },
      {
        id: "10",
        text: "10",
      },
      {
        id: "11",
        text: "11",
      },
      {
        id: "12",
        text: "12",
      },
    ],
    listaMoneda: [
      {
        id: "PEN",
        value: "PEN",
        text: "Soles (S/)",
        symbol: "S/.",
        selected: false,
      },
      {
        id: "USD",
        value: "USD",
        text: "Dólares ($)",
        symbol: "$",
        selected: false,
      },
    ],
    listaDocumentoCobro: [
      {
        id: "0001",
        text: "CP-000001",
        selected: true,
      },
      {
        id: "000002",
        text: "CP-000002",
        selected: false,
      },
    ],
    listaCompania: [
      {
        id: "1",
        text: "Rimac Seguros",
        value: "1",
        selected: true,
      },
    ],
    listaTipo: [
      {
        id: "1",
        text: "Poliza Existente",
        selected: true,
      },
      {
        id: "2",
        text: "Poliza Nueva",
        selected: false,
      },
    ],
    //
    cantidadRemesas: 0,
    listaRemesas: this.props.listaRemesas,
    paginacion: [],
    listaDetalleRemesas: [],
    formValido: true,
    nohayremesas: false,
    buscadorMobile: "",
    intervalId: "",
    //Ini - M.315456.01
    //selectedItemTipoOperacionTab1: "",
    //Fin - M.315456.01
    selectedItemTipoOperacionTab2: "",
    selectedItemTipoOperacionCobTab1: "",
    selectedItemTipoOperacionCobTab2: "",
    selectedItemMonedaTab1: "",
    selectedItemMonedaTab2: "",
    selectedItemNumCuotasTab1: "",
    selectedItemNumCuotasTab2: "",
    listaMoneda1: [],
    listaMoneda2: [],
    listaCuotasTab1: [],
    listaCuotasTab2: [],
    //Ini - M.315456.01
    showCertificadoTab1: false,
    //Fin - M.315456.01
    certificado: "",
  };

  componentDidMount() {
    M.AutoInit();
  }

  componentDidUpdate() {
    M.AutoInit();
  }

  async componentDidMount() {
    M.AutoInit();
    this.props.showSection("Footer", true);
    if ("true" !== localStorage.getItem("login")) {
      await Auth.signOut();
    }

    Auth.currentUserInfo().then((response) => {
      this.setState({
        usuario:
          response && response.attributes.email
            ? response.attributes.email
            : "",
      });
    });
  }

  //SOLO DNI 1ER PAGE
  handleChange = (e) => {
    let { name, value } = e.target;
    const onlynumber = /^[0-9]*$/;
    const alfanumeric = /^[0-9A-Za-záÁéÉíÍóÓúÚÑñ&.-/\s]*$/i;

    if (name === "tipoDocumento") {
      document.getElementById("nroDocumento").focus();
      this.setState({ [name]: value });
      if (value === "2") {
        this.setState({ inputMax: "8", nroDocumento: "", inputValid: true });
      } else if (value === "4") {
        this.setState({ inputMax: "12", nroDocumento: "", inputValid: true });
      } else if (value === "6") {
        this.setState({ inputMax: "12", nroDocumento: "", inputValid: true });
      }
    } else if (name === "nroDocumento") {
      if (this.state.tipoDocumento === "2") {
        if (onlynumber.test(value)) {
          this.setState({ [name]: value });
          if (value.length === 8) {
            this.setState({ inputValid: false });
          }
        }
      } else if (this.state.tipoDocumento === "4") {
        if (alfanumeric.test(value)) {
          this.setState({ [name]: value.toUpperCase() });
          if (value.length > 2) {
            this.setState({ inputValid: false });
          }
        }
      } else if (this.state.tipoDocumento === "6") {
        if (alfanumeric.test(value)) {
          this.setState({ [name]: value.toUpperCase() });
          if (value.length > 2) {
            this.setState({ inputValid: false });
          }
        }
      } else {
        if (onlynumber.test(value)) {
          this.setState({ [name]: value });
        }
      }
    }
  };

  onChange = (e) => {
    let { name, value } = e.target;
    if ("ideDireccion" === name) {
      this.setState(
        {
          [name]: value.split(CONSTANTES.SEPARADOR)[0],
          formValido: true,
          ["dsc" + name.substring(3, name.length)]: value.split(
            CONSTANTES.SEPARADOR
          )[1],
        },
        () => {}
      );
    } else if ("numeroDocumentoCobro" === name) {
      const re = /^[0-9\b]+$/;
      if (value === "" || re.test(value)) {
        this.setState({ [name]: value });
      }
    } else if ("pagoFacil" === name) {
      const re = /^[0-9\b]+$/;
      if (value === "" || re.test(value)) {
        this.setState({ [name]: value });
      }
    } else if ("codigoProductoTab1" === name) {
      const re = /^[0-9\b]+$/;
      if (value === "" || re.test(value)) {
        this.setState({ [name]: value, codigoProductoTab1Error: false });
      }
    } else if ("codigoProductoTab2" === name) {
      const re = /^[0-9\b]+$/;
      if (value === "" || re.test(value)) {
        this.setState({ [name]: value, codigoProductoTab2Error: false });
      }
    } else if ("total" === name) {
      /* const re = /^[0-9.\b]+$/;
            if (value === '' || re.test(value)) {
                this.setState({ [name] : value, totalError: false });
            }*/

      const re = /^[0-9.\b]+$/;
      var total = this.state.total != null ? this.state.total : "";

      var existePunto = total.indexOf(".");
      var existePuntoLast = value.lastIndexOf(".");

      if (existePuntoLast > existePunto && existePunto > 0) {
        existePunto = "0";
      } else {
        existePunto = "-1";
      }
      if (value.length == 1 && value == ".") {
        existePunto = "0";
      }
      if ((value === "" || re.test(value)) && existePunto == "-1") {
        /*this.setState({
                 [e.target.name]: e.target.value
                });*/
        this.setState({ [name]: value, totalError: false, totalTemp: value });
      }
    } else if ("polizaTab1" === name) {
      const re = /^[\w\-\s]+$/;
      if (value === "" || re.test(value)) {
        this.setState({ [name]: value, polizaTab1Error: false });
      }
    } else if ("polizaTab2" === name) {
      const re = /^[\w\-\s]+$/;
      if (value === "" || re.test(value)) {
        this.setState({ [name]: value, polizaTab2Error: false });
      }
    } else if ("monedaTab1" === name) {
      this.setState({ [name]: value, monedaTab1Error: false }, () => {});
      for (let index = 0; index < this.state.listaMoneda.length; index++) {
        if (this.state.listaMoneda[index].id == value) {
          this.state.listaMoneda[index].selected = true;
        } else {
          this.state.listaMoneda[index].selected = false;
        }
      }
    } else if ("monedaTab2" === name) {
      this.setState({ [name]: value, monedaTab2Error: false }, () => {});
      for (let index = 0; index < this.state.listaMoneda.length; index++) {
        if (this.state.listaMoneda[index].id == value) {
          this.state.listaMoneda[index].selected = true;
        } else {
          this.state.listaMoneda[index].selected = false;
        }
      }
    } else {
      this.setState({ [name]: value, emailClienteTab2Error: false }, () => {});
    }
  };

  onChangeProductoTab1 = (e) => {
    this.setState(
      {
        productoTab1: e.id,
        name_productoTab1: e.text,
        productoTab1Error: false,
      },
      function () {
        if (e.id) {
          this.limpiarCambioTipoTab1();
        }
          //Ini - M.315456.01
          if (e.id == "VIDA"){
             this.setState({listaOperacionCob: LISTA_OPERACION_COB_VIDA});
            
          }
          else if(e.id === "VE" || e.id === "RG" || e.id =="SD"){
            this.setState({listaOperacionCob: LISTA_OPERACION_COB});
          }

          if (e.id === "VE" || e.id === "RG"){
            this.setState({showCertificadoTab1: true});
      }
          else{
            this.setState({showCertificadoTab1: false});
      }
          
      }
        //Fin - M.315456.01

    );
  };

  onChangeProductoTab2 = (e) => {
    this.setState(
      {
        productoTab2: e.id,
        name_productoTab2: e.text,
        productoTab2Error: false,
        listaOperacion2: LISTA_TIPO_OPERACIONES,        
      },
      function () {
        this.setState({ selectedItemTipoOperacionCobTab2: "" });
        if (e.id) {
          this.limpiarCambioTipoTab2();
          //buscamos sus documentos de cobro
          if (this.state.tipoTab2 == "1") {
            this.buscarCobros();
            this.setState({
              disabledCodProducto: true,
              disabledNumPoliza: true,
              disabledMoneda: true,
            });
          } else {
            this.setState({
              disabledCodProducto: false,
              disabledNumPoliza: false,
              disabledMoneda: false,
            });
          }
        }
      }
    );
  };

  onChangeMoneda2 = (e) => {
    this.setState(
      { monedaTab2: e.id, name_moneda: e.text, monedaTab2Error: false },
      function () {}
    );
  };

  onChangeCompania = (e) => {
    this.setState({
      compania: e.id,
      name_compania: e.text,
      companiaError: false,
    });
  };

  onChangeTipo = (e) => {
    this.limpiarCambioTipoTab2();
    this.setState({
      tipoTab2: e.id,
      name_tipo: e.text,
      tipoTab2Error: false,
      listaOperacion2: LISTA_TIPO_OPERACIONES,
    });
    if (e.id == "2") {
      this.setState({ showPolizaExistente: false, showNumPoliza: false });
    } else {
      this.setState({ showPolizaExistente: true, showNumPoliza: true });
      if (this.state.productoTab2 !== "VIDA")
        this.setState({
          disabledCodProducto: true,
          disabledNumPoliza: true,
          disabledMoneda: true,
        });
      else
        this.setState({
          disabledCodProducto: false,
          disabledNumPoliza: false,
          disabledMoneda: false,
        });

      if (this.state.productoTab2) {
        this.buscarCobros();
      }
    }
  };

  onChangeDocumentoCobro = (e) => {
    this.setState({
      documentoCobro: e.id,
      name_documentoCobro: e.text,
      documentoCobroError: false,
    });
  };

  onChangeDocumentoCobrov2 = (e) => {
    this.setState({
      documentoCobro: e,
      name_documentoCobro: e,
      documentoCobroError: false,
    });
  };

  onChangeOperacionCobTab1 = (e) => {
    this.setState({
      tipoOperacionCobTab1: e.id,
      tipoOperacionCobTab1Error: false,
      name_tipoOperacionCobTab1: e.text,
    });
    var ltipOper = e.id.split(CONSTANTES.SEPARADOR)[0];
    this.state.numCuotasTab1 = "";
    if (ltipOper === "CVC") {
      this.state.numCuotasTab1 = CONSTANTES.SEPARADOR;
      this.state.disabledCuotaTab1 = true;
      this.setState({ numCuotasTab1Error: false });
      this.setState({ selectedItemNumCuotasTab1: "" });
    } else if (ltipOper === "FIN") {
      this.state.numCuotasTab1 = CONSTANTES.SEPARADOR;
      this.state.disabledCuotaTab1 = false;
    }
    this.setState({ selectedItemTipoOperacionCobTab1: e });
  };

  onChangeOperacionCobTab2 = (e) => {
    var ltipOper = e.id.split(CONSTANTES.SEPARADOR)[0];
    ///validacion cvc cc
    if (
      ltipOper === "CVC" &&
      this.state.tipoDocumentoCob &&
      this.state.tipoDocumentoCob !== "CC" &&
      this.state.tipoDocumentoCob !== "VT" &&
      this.state.tipoDocumentoCob !== "AE" &&
      this.state.tipoDocumentoCob !== "LV"
    ) {
      this.mostrarModal(
        "mensaje",
        "Seleccionar operación de cobro: Financiamiento"
      );
      this.setState({
        selectedItemTipoOperacionCobTab2: "",
        tipoOperacionCobTab2: "",
      });
      return true;
    }

    if (ltipOper === "FIN" && (this.state.tipoOperacionTab2 === "PAGO_EN_LINEA_SUSCRIPCION" || this.state.tipoOperacionTab2 === "SUSCRIPCION") && this.state.productoTab2 === "VIDA") {
      this.mostrarModal(
        "mensaje",
        "Los productos de vida no pueden ser financiados"
      );
      this.setState({
        tipoOperacionCobTab2: "",
        selectedItemTipoOperacionCobTab2: "",
      });
      
      return true;
    }

    if (ltipOper === "FIN" && this.state.tipoOperacionTab2 === "PAGO_EN_LINEA_SUSCRIPCION") {
      this.setState({disabledMonto: false, total: '0.00'});
    }else{
      this.setState({disabledMonto: true, total: this.state.totalTemp});
    }

    this.setState({
      tipoOperacionCobTab2: e.id,
      tipoOperacionCobTab2Error: false,
      name_tipoOperacionCobTab2: e.text,
    });

    //this.state.numCuotasTab2 = '';
    if (ltipOper === "CVC") {
      this.state.numCuotasTab2 = CONSTANTES.SEPARADOR;
      this.state.disabledCuotaTab2 = true;
      this.setState({ numCuotasTab2Error: false });
      this.setState({ selectedItemNumCuotasTab2: "" });
    } else if (ltipOper === "FIN") {
      //this.state.numCuotasTab2 = CONSTANTES.SEPARADOR;
      this.state.disabledCuotaTab2 = false;
    }
    this.setState({ selectedItemTipoOperacionCobTab2: e });

  };

  onChangeOperacionTab2 = (e) => {
    var ltipOper = e.id.split(CONSTANTES.SEPARADOR)[0];
    this.setState({
      tipoOperacionTab2: e.id,
      tipoOperacionTab2Error: false,
      disabledMonto: false,
      disabledOpCob: false,
      disabledCuotaTab2: false,
      totalError: false,
      name_tipoOperacionTab2: e.text,
    });
    if (ltipOper === "SUSCRIPCION") {
      this.setState({ total: "0", disabledMonto: true });
    } else if (ltipOper === "PAGO_EN_LINEA") {
      this.setState({
        disabledOpCob: true,
        disabledCuotaTab2: true,
        tipoOperacionCobTab2Error: false,
        numCuotasTab2Error: false,
      });
      this.setState({
        selectedItemNumCuotasTab2: "",
      });
      this.setState({ numCuotasTab2: "" });
      this.setState({
        total: this.state.totalTemp
          ? Number(this.state.totalTemp).toFixed(2)
          : "0",
        disabledMonto: this.state.codigoProductoTab2 == CONSTANTES.CODE_FLEXIVIDA && this.state.tipoTab2 === "1" ? true : false
      });
    } else {
      this.setState({ disabledMonto: false });
      this.setState({
        total: this.state.totalTemp
          ? Number(this.state.totalTemp).toFixed(2)
          : "0",
      });
    }
    if (this.state.tipoOperacionCobTab2 === "FIN" && (ltipOper === "PAGO_EN_LINEA_SUSCRIPCION" || ltipOper === "SUSCRIPCION") && this.state.productoTab2 === "VIDA") {
      this.mostrarModal(
        "mensaje",
        "Los productos de vida no pueden ser financiados"
      );
    }

    this.setState({ selectedItemTipoOperacionTab2: e });
    if (e.id !== LISTA_TIPO_OPERACIONES[2].id && this.state.tipoTab2 === "1" ) {
      this.setState({
        disabledMonto: true,
      });
    }

    this.setState({
      selectedItemTipoOperacionCobTab2: "",
      tipoOperacionCobTab2: "",
      name_tipoOperacionCobTab2: "",
    });
  };

  onChangeListaCuotasTab1 = (e) => {
    this.setState({ numCuotasTab1Error: false });
    this.setState({ numCuotasTab1: e.id });
    this.setState({ selectedItemNumCuotasTab1: e });
  };

  onChangeListaCuotasTab2 = (e) => {
    this.setState({ numCuotasTab2Error: false });
    this.setState({ numCuotasTab2: e.id });
    this.setState({ selectedItemNumCuotasTab2: e });
  };

  onChangeMonedaTab1 = (e) => {
    this.setState({ monedaTab1Error: false });
    this.setState({ monedaTab1: e.id });
    this.setState({ selectedItemMonedaTab1: e });
  };

  onChangeMonedaTab2 = (e) => {
    this.setState({ monedaTab2Error: false });
    this.setState({ monedaTab2: e.id });
    this.setState({ selectedItemMonedaTab2: e });
  };

  validarFormularioTab2 = (e) => {
    let { value, name } = e.target;
    if ("total" === name) {
      var valor = value != null && value != "" ? value : "0";
      this.setState({
        [e.target.name]: parseFloat(valor).toFixed(2),
      });

      this.setState({ ["v_" + name]: Utils.validarCampo(name, value) }, () => {
        this.setState({
          formValido: Utils.validarFormState(this.state, "filtro"),
        });
      });
    } else {
      this.setState({ ["v_" + name]: Utils.validarCampo(name, value) }, () => {
        this.setState({
          formValido: Utils.validarFormState(this.state, "filtro"),
        });
      });
    }
  };

  handleSubmit = () => {
    if (!this.state.inputValid) {
      this.props.mostrarLoading();
      let request = {
        tipoDocumento: this.state.tipoDocumento,
        numeroDocumento: this.state.nroDocumento,
      };
      this.setState({ showMetpagos: true, metpagosLoader: true });
      this.props.props
        .callService(
          "GET",
          "metodo-pago/obtener",
          { ...request },
          obtenerMetodosPago
        )
        .then((response) => {
          if (response) {
            let val = response.data.payload.length === 0;
            if (200 === response.status && val === false) {
              this.setState(
                { payments: response.data.payload}
              );
            }
          } 
        })
        .catch((error) => {
          console.error(error);
        });
      
      this.setState({ metpagosLoader: false });
      this.props.ocultarLoading();
    }
  };

  backMetpagos = () => {
    this.limpiarBusqueda();
    document.getElementById("tipoDocumento").value = "2";
    this.setState({
      tipoDocumento: "2",
      showMetpagos: false,
      successafil: false,
      emailClienteTab2Error: false,
      nextafiliacion: false,
      payments: "",
    });
  };

  handleTab = (e) => {
    // this.limpiarPreResultado();
    document
      .querySelectorAll(".tabIndex")
      .forEach(function (valor, indice, array) {
        document
          .getElementById("tab" + (indice + 1))
          .classList.remove("active");
        document.querySelector(".tab" + (indice + 1)).classList.remove("show");
      });
    document.querySelector("." + e.target.id).classList.add("show");
    e.target.classList.add("active");
  };

  selectCard = (item, id) => {
    this.setState({ cardselected: true, codigoTarjeta: item.codigoTarjeta });
    document
      .querySelectorAll(".bxmetpago")
      .forEach(function (valor, indice, array) {
        document.getElementById("check" + indice).style.background = "#ffff";
        document.getElementById("check" + indice).style.borderColor = "#C5CBE0";
        document.getElementById("bx" + indice).style.borderColor = "#F0F2FA";
      });
    document.getElementById("check" + id).style.background = "#83CC5E";
    document.getElementById("check" + id).style.borderColor = "#83CC5E";
    document.getElementById("bx" + id).style.borderColor = "#83CC5E";
    this.setState({ pagoFacil: item.numeroPagoFacil });
  };

  nextafiliacion(e) {
    this.setState({ nextafiliacion: true, moneda: "PEN" });
  }

  handleAfiliacion = () => {
    if (this.validarEnvioTab1(true)) {
      let request = {
        nombres: this.state.aseguradoNombre,
        apellido:
          this.state.aseguradoApellidoPat +
          " " +
          this.state.aseguradoApellidoMat,
        tipoDocumento: this.state.tipoDocumento,
        numeroDocumento: this.state.nroDocumento,
        // Ini - M.315456.01
        operacion: 'SUSCRIPCION', //this.state.tipoOperacionTab1,
        // Fin - M.315456.01
        operacionCob: this.state.tipoOperacionCobTab1,
        nombreProducto: this.state.productoTab1,
        codigoProducto: this.state.codigoProductoTab1,
        numeroPoliza: this.state.polizaTab1,
        numeroCuotas: this.state.numCuotasTab1,
        operador: this.state.codigoTarjeta,
        // Ini - M.315456.01
        // emailCliente: this.state.emailClienteTab1,
        numeroCertificado: this.state.certificadoTab1,
        // Fin - M.315456.01
        emailAsesor: this.state.emailAsesor,
        numeroPagoFacil: this.state.pagoFacil,
        moneda: this.state.monedaTab1,
      };

      this.props.mostrarLoading();
      this.props.props
        .callService("POST", "metodo-pago/afiliar", { ...request }, null)
        .then((response) => {     
          if (response.data.status == 200) {
            this.props.ocultarLoading();

            this.setState({ successafil: true });
          } else if (response.data.status == 406) {
            this.mostrarModal(
              "mensaje",
              "Su sesión ha sido cerrada desde otro dispositivo, se cerrará la sesión"
            );
            new Promise((resolve, reject) => {
              setTimeout(function () {
                Auth.signOut();
                resolve(true);
              }, 1500);
            }).then(() => {
              const indexURL = window.location.href.indexOf(
                CONSTANTES.RUTA.basename
              );
              const urlRedirect = window.location.href.substring(0, indexURL);
              window.location.href =
                urlRedirect + CONSTANTES.RUTA.basename + CONSTANTES.RUTA.login;
            });
          } else {
            let data;
            if(request.operacionCob = 'CVC'){
               data = response.data.afiliacion.error.message;              
            }
            else
            {
               data = response.data.message;
            }
           
            this.props.ocultarLoading();
            if (data == "undefined") {
              data =
                " error de datos ingresados, verifique con el administrador";
            }
            this.mostrarModal(
              "mensaje",
              "Ocurrio un error al registrar los datos: " + data
            );
          }
        })
        .catch((err) => {
          console.log(err);
          this.props.ocultarLoading();
        });

      this.setState({
        //Ini - M.315456.01
        //selectedItemTipoOperacionTab1: "",
        //Fin - M.315456.01
        selectedItemTipoOperacionCobTab1: "",
        selectedItemNumCuotasTab1: "",
        selectedItemMonedaTab1: "",
      });
    }
  };

  enviarCorreo = () => {
    if (this.validarEnvioTab2()) {
      let request = {
        numId: this.state.numIdTercero,
        nombres: this.state.aseguradoNombre,
        apePat: this.state.aseguradoApellidoPat,
        apeMat: this.state.aseguradoApellidoMat,
        tipDoc: this.state.tipoDocumento.split(CONSTANTES.SEPARADOR)[0],
        numDoc: this.state.nroDocumento,
        tipOp: this.state.tipoOperacionCobTab2.split(CONSTANTES.SEPARADOR)[0],
        tipOpeCob: this.state.tipoOperacionTab2.split(CONSTANTES.SEPARADOR)[0],
        producto: this.state.productoTab2.split(CONSTANTES.SEPARADOR)[0],
        codProd: this.state.codigoProductoTab2,
        numPoliza: this.state.polizaTab2,
        numCuotas: this.state.numCuotasTab2.split(CONSTANTES.SEPARADOR)[0],
        emailCliente: this.state.emailClienteTab2,
        emailAsesor: this.state.emailAsesor,
        moneda: this.state.monedaTab2.split(CONSTANTES.SEPARADOR)[0],
        monto:
          this.state.tipoOperacionTab2.split(CONSTANTES.SEPARADOR)[0] ==
          "SUSCRIPCION"
            ? null
            : this.state.total,
        documentoCobro: this.state.documento,
        documentos: this.state.documentos,
        certificado: this.state.certificado,
      };
      this.props.mostrarLoading();
      this.props.props
        .callService("POST", "afiliacion", { ...request }, null)
        .then((response) => {
          let data = response.data.message;
          if (response.data.status == 200) {
            this.props.ocultarLoading();
            this.limpiarBusqueda();
            this.mostrarModal("mensaje", "EL CORREO SE ENVIÓ CON ÉXITO");
            this.backMetpagos();
          } else if (response.data.status == 406) {
            this.mostrarModal(
              "mensaje",
              "Su sesión ha sido cerrada desde otro dispositivo, se cerrará la sesión"
            );
            new Promise((resolve, reject) => {
              setTimeout(function () {
                //localStorage.clear();
                Auth.signOut();
                resolve(true);
              }, 1500);
            }).then(() => {
              const indexURL = window.location.href.indexOf(
                CONSTANTES.RUTA.basename
              );
              const urlRedirect = window.location.href.substring(0, indexURL);
              window.location.href =
                urlRedirect + CONSTANTES.RUTA.basename + CONSTANTES.RUTA.login;
            });
          } else {
            this.props.ocultarLoading();
            if (data == "undefined") {
              data =
                " error de datos ingresados, verifique con el administrador";
            }
            this.mostrarModal(
              "mensaje",
              "Ocurrio un error al registrar los datos " + data
            );
          }
        })
        .catch((err) => {
          console.log(err);
          this.props.ocultarLoading();
        });

      this.setState({
        selectedItemTipoOperacionTab2: "",
        selectedItemTipoOperacionCobTab2: "",
        selectedItemNumCuotasTab2: "",
        selectedItemMonedaTab2: "",
      });
    }
  };

  buscarTercero = () => {
    if (
      this.state.nroDocumento == "" ||
      this.state.tipoDocumento == "" ||
      this.state.tipoDocumento == CONSTANTES.SEPARADOR
    ) {
      this.mostrarModal("mensaje", "Ingrese Criterios Valido de busqueda");
    } else {
      let request = {
        tipDoc: this.state.tipoDocumento.split(CONSTANTES.SEPARADOR)[0],
        numDoc: this.state.nroDocumento,
        accion: "getTercero",
      };
      this.props.mostrarLoading();

      this.props.props
        .callService("POST", "afiliacion", { ...request }, null)
        .then((response) => {
          this.state.showBusqueda = "";
          // this.limpiarPreResultado();
          let data = response.data.message;
          if (response.data.status == 200) {
            if (isNaN(Number(data.tercero))) {
              data.tercero = "0"; // si no es un numero enviamos 0
            }
            this.state.disabledNumdoc = true;
            this.state.disabledTipoDoc = true;
            //  this.state.tipoDocumento = "" + data.tipoDocumento;
            this.state.nroDocumento = data.numeroDocumento;
            this.state.textTipoDocumento =
              this.state.listaTipoDocumentos.filter(
                (val) => val.value == data.tipoDocumento
              )[0]["detalle"];
            this.state.aseguradoNombre =
              data.nombres.charAt(0).toUpperCase() + data.nombres.slice(1);
            this.state.aseguradoApellidoPat = data.apellidoPaterno;
            this.state.aseguradoApellidoMat = data.apellidoMaterno;
            this.state.numIdTercero = data.tercero;
            //this.state.emailCliente = data.correo;

            // Ini - M.315456.01
            // this.state.emailClienteTab1 = data.correo;
            // Fin - M.315456.01

            this.state.emailClienteTab2 = data.correo;
            this.state.emailAsesor = this.state.usuario;
            this.state.showBusqueda = "";

            this.handleSubmit();

            /*if (data.tercero != '0'){
                        //buscamos sus documentos de cobro 
                        this.buscarCobros(data.tercero);
                    }*/
          } else if (response.data.status == 406) {
            this.mostrarModal(
              "mensaje",
              "Su sesión ha sido cerrada desde otro dispositivo, se cerrará la sesión"
            );
            new Promise((resolve, reject) => {
              setTimeout(function () {
                //localStorage.clear();
                Auth.signOut();
                resolve(true);
              }, 1500);
            }).then(() => {
              const indexURL = window.location.href.indexOf(
                CONSTANTES.RUTA.basename
              );
              const urlRedirect = window.location.href.substring(0, indexURL);
              window.location.href =
                urlRedirect + CONSTANTES.RUTA.basename + CONSTANTES.RUTA.login;
            });
          } else {
            this.mostrarModal("mensaje", "El documento no existe");
            this.state.showBusqueda = "None"; // comentar luego ya que por error no debe entrar
            this.state.disabledNumdoc = false;
            this.state.disabledTipoDoc = false;
          }
          this.props.ocultarLoading();
        })
        .catch((err) => {
          this.state.showBusqueda = "None"; // comentar luego ya que por error no debe entrar
          this.state.disabledNumdoc = false;
          this.state.disabledTipoDoc = false;
          console.log(err);
          this.props.ocultarLoading();
        });
    }
  };

  buscarCobros = (numid) => {
    if (
      this.state.nroDocumento == "" ||
      this.state.tipoDocumento == "" ||
      this.state.tipoDocumento == CONSTANTES.SEPARADOR
    ) {
      this.mostrarModal("mensaje", "Ingrese Criterios Valido de busqueda");
    } else {
      let request = {
        //tipDoc: this.state.tipoDocumento.split(CONSTANTES.SEPARADOR)[0],
        //numDoc: this.state.nroDocumento,
        numId: this.state.numIdTercero,
        producto:
          this.state.productoTab1 != ""
            ? this.state.productoTab1
            : this.state.productoTab2,
        accion: "getCobros",
      };
      this.props.mostrarLoading();

      this.props.props
        .callService("POST", "afiliacion", { ...request }, null)
        .then((response) => {
          //this.state.showBusqueda = '';
          // this.limpiarPreResultado();
          let data = response.data.message;
          if (response.data.status == 200) {
            if (data.length > 0) {
              this.state.listaDocumentoCobro = data;
              this.state.showDocumentoCobro = "";
            } else {
              this.state.listaDocumentoCobro = [];
              this.state.showDocumentoCobro = ""; //'None';
            }
          } else if (response.data.status == 406) {
            this.mostrarModal(
              "mensaje",
              "Su sesión ha sido cerrada desde otro dispositivo, se cerrará la sesión"
            );
            new Promise((resolve, reject) => {
              setTimeout(function () {
                //localStorage.clear();
                Auth.signOut();
                resolve(true);
              }, 1500);
            }).then(() => {
              const indexURL = window.location.href.indexOf(
                CONSTANTES.RUTA.basename
              );
              const urlRedirect = window.location.href.substring(0, indexURL);
              window.location.href =
                urlRedirect + CONSTANTES.RUTA.basename + CONSTANTES.RUTA.login;
            });
          } else {
            //this.mostrarModal('mensaje', 'El documento no existe');
            this.state.showDocumentoCobro = "None"; // comentar luego ya que por error no debe entrar
            this.state.listaDocumentoCobro = [];
          }
          this.props.ocultarLoading();
        })
        .catch((err) => {
          this.state.showDocumentoCobro = "None"; // comentar luego ya que por error no debe entrar
          console.log(err);
          this.props.ocultarLoading();
        });
    }
  };

  showErrorsTab1 = (update) => {
    let regExp = /\S+@\S+\.\S+/;

    if (
      this.state.productoTab1 === CONSTANTES.SEPARADOR ||
      this.state.productoTab1 === ""
    ) {
      this.setState({ productoTab1Error: true });
    } else {
      this.setState({ productoTab1Error: false });
    }

    if (
      this.state.tipoOperacionCobTab1 === CONSTANTES.SEPARADOR ||
      this.state.tipoOperacionCobTab1 === ""
    ) {
      this.setState({ tipoOperacionCobTab1Error: true });
    } else {
      this.setState({ tipoOperacionCobTab1Error: false });
    }

    if (
      this.state.tipoOperacionCobTab1.split(CONSTANTES.SEPARADOR)[0] == "FIN" &&
      this.state.numCuotasTab1.split(CONSTANTES.SEPARADOR)[0] === ""
    ) {
      this.setState({ numCuotasTab1Error: true });
    } else {
      this.setState({ numCuotasTab1Error: false });
    }
    //Ini - M.315456.01
    // if (
    //   this.state.tipoOperacionTab1 === CONSTANTES.SEPARADOR ||
    //   this.state.tipoOperacionTab1 === ""
    // ) {
    //   this.setState({ tipoOperacionTab1Error: true });
    // } else {
    //   this.setState({ tipoOperacionTab1Error: false });
    // }
    //Fin - M.315456.01
    if (this.state.codigoProductoTab1 === "") {
      this.setState({ codigoProductoTab1Error: true });
    } else {
      this.setState({ codigoProductoTab1Error: false });
    }

    if (this.state.polizaTab1 === "") {
      this.setState({ polizaTab1Error: true });
    } else {
      this.setState({ polizaTab1Error: false });
    }

    //Ini - M.315456.01
    if ((this.state.certificadoTab1 === "" || this.state.certificadoTab1 === 0 )
        && (this.state.productoTab1.split(CONSTANTES.SEPARADOR)[0] == "VE" || this.state.productoTab1.split(CONSTANTES.SEPARADOR)[0] == "RG")
       ) 
    {
      this.setState({ certificadoTab1Error: true });
    } else {
      this.setState({ certificadoTab1Error: false });
    }
    //Fin - M.315456.01

    // Ini - M.315456.01
    // if (
    //   (!update && this.state.emailClienteTab1 === "") ||
    //   !regExp.test(this.state.emailClienteTab1)
    // ) {
    //   this.setState({ emailClienteTab1Error: true });
    // } else {
    //   this.setState({ emailClienteTab1Error: false });
    // }    
    if (
      this.state.monedaTab1 === CONSTANTES.SEPARADOR ||
      this.state.monedaTab1 === ""
    ) {
      this.setState({ monedaTab1Error: true });
    } else {
      this.setState({ monedaTab1Error: false });
    }
  };
   
  showErrorsTab2 = (update) => {
    let regExp = /\S+@\S+\.\S+/;

    if (
      this.state.compania === CONSTANTES.SEPARADOR ||
      this.state.compania === ""
    ) {
      this.setState({ companiaError: true });
    } else {
      this.setState({ companiaError: false });
    }

    if (
      this.state.tipoTab2 === CONSTANTES.SEPARADOR ||
      this.state.tipoTab2 === ""
    ) {
      this.setState({ tipoTab2Error: true });
    } else {
      this.setState({ tipoTab2Error: false });
    }

    if (
      this.state.productoTab2 === CONSTANTES.SEPARADOR ||
      this.state.productoTab2 === ""
    ) {
      this.setState({ productoTab2Error: true });
    } else {
      this.setState({ productoTab2Error: false });
    }

    if (
      this.state.tipoOperacionTab2 === CONSTANTES.SEPARADOR ||
      this.state.tipoOperacionTab2 === ""
    ) {
      this.setState({ tipoOperacionTab2Error: true });
    } else {
      this.setState({ tipoOperacionTab2Error: false });
    }

    if (
      (this.state.tipoOperacionCobTab2 === CONSTANTES.SEPARADOR ||
        this.state.tipoOperacionCobTab2 === "") &&
      this.state.tipoOperacionTab2.split(CONSTANTES.SEPARADOR)[0] !=
        "PAGO_EN_LINEA" &&
      this.state.tipoTab2.split(CONSTANTES.SEPARADOR)[0] == "1"
    ) {
      this.setState({ tipoOperacionCobTab2Error: true });
    } else {
      this.setState({ tipoOperacionCobTab2Error: false });
    }

    if (this.state.codigoProductoTab2 === "") {
      this.setState({ codigoProductoTab2Error: true });
    } else {
      this.setState({ codigoProductoTab2Error: false });
    }

    if (
      this.state.tipoTab2.split(CONSTANTES.SEPARADOR)[0] != "2" &&
      this.state.polizaTab2 === ""
    ) {
      this.setState({ polizaTab2Error: true });
    } else {
      this.setState({ polizaTab2Error: false });
    }

    if (
      (!update && this.state.emailClienteTab2 === "") ||
      !regExp.test(this.state.emailClienteTab2)
    ) {
      this.setState({ emailClienteTab2Error: true });
    } else {
      this.setState({ emailClienteTab2Error: false });
    }

    //if ( this.state.total === '' &&  this.state.tipoOperacionTab2 != 'SUSCRIPCION'){
    if (this.state.total === "") {
      this.setState({ totalError: true });
    } else {
      this.setState({ totalError: false });
    }

    if (
      this.state.monedaTab2 === CONSTANTES.SEPARADOR ||
      this.state.monedaTab2 === ""
    ) {
      this.setState({ monedaTab2Error: true });
    } else {
      this.setState({ monedaTab2Error: false });
    }

    if (
      this.state.tipoOperacionCobTab2.split(CONSTANTES.SEPARADOR)[0] == "FIN" &&
      this.state.numCuotasTab2.split(CONSTANTES.SEPARADOR)[0] === ""
    ) {
      this.setState({ numCuotasTab2Error: true });
    } else {
      this.setState({ numCuotasTab2Error: false });
    }

    if (
      this.state.tipoTab2.split(CONSTANTES.SEPARADOR)[0] == "1" &&
      this.state.documento === "" &&
      this.state.productoTab2.split(CONSTANTES.SEPARADOR)[0] != "VIDA"
    ) {
      this.setState({ documentoCobroTab2Error: true });
    } else {
      this.setState({ documentoCobroTab2Error: false });
    }
  };

  validarEnvioTab1 = (update) => {
    let regExp = /\S+@\S+\.\S+/;
    this.showErrorsTab1(update);
    if (
      this.state.productoTab1 === CONSTANTES.SEPARADOR ||
      this.state.productoTab1 === ""
    ) {
      console.log("error producto");
      return 0;
    } else if (
      this.state.tipoOperacionTab1 === CONSTANTES.SEPARADOR ||
      this.state.tipoOperacionTab1 === ""
    ) {
      console.log("error tipoOperacion");
      return 0;
    } else if (
      (this.state.tipoOperacionCobTab1 === CONSTANTES.SEPARADOR ||
        this.state.tipoOperacionCobTab1 === "") &&
      this.state.tipoOperacionTab1.split(CONSTANTES.SEPARADOR)[0] !=
        "PAGO_EN_LINEA" &&
      this.state.tipoTab1.split(CONSTANTES.SEPARADOR)[0] == "1"
    ) {
      console.log("error tipoOperacionCob");
      return 0;
    } else if (this.state.codigoProductoTab1 === "") {
      console.log("error codigo producto");
      return 0;
    }    
     else if (
      this.state.monedaTab1 === CONSTANTES.SEPARADOR ||
      this.state.monedaTab1 === ""
    ) {
      console.log("error moneda");
      return 0;
    }
    if (
      this.state.tipoOperacionCobTab1.split(CONSTANTES.SEPARADOR)[0] ===
        "FIN" &&
      this.state.numCuotasTab1.split(CONSTANTES.SEPARADOR)[0] === ""
    ) {
      console.log("error numCuotas");
      return 0;
    }
    return 1;
  };

  validarEnvioTab2 = (update) => {
    let regExp = /\S+@\S+\.\S+/;
    this.showErrorsTab2(update);
    if (
      this.state.tipoOperacionTab2.split(CONSTANTES.SEPARADOR)[0] !=
        "SUSCRIPCION" &&
      this.state.total <= 0
    ) {
      this.mostrarModal(
        "mensaje",
        "Operacion no permitida: Ingrese un monto mayor a 0"
      );
      return 0;
    } else if (
      this.state.compania === CONSTANTES.SEPARADOR ||
      this.state.compania === ""
    ) {
      console.log("error compania");
      return 0;
    } else if (
      this.state.tipoTab2 === CONSTANTES.SEPARADOR ||
      this.state.tipoTab2 === ""
    ) {
      console.log("error tipo");
      return 0;
    } else if (
      this.state.productoTab2 === CONSTANTES.SEPARADOR ||
      this.state.productoTab2 === ""
    ) {
      console.log("error producto");
      return 0;
    } else if (
      this.state.tipoOperacionTab2 === CONSTANTES.SEPARADOR ||
      this.state.tipoOperacionTab2 === ""
      ||  this.state.selectedItemTipoOperacionTab2 === '' //RTC311646
    ) 
    {
      this.setState({ tipoOperacionTab2Error: true }); //RTC311646
      console.log("error tipoOperacion");
      return 0;
    } else if (
      (this.state.tipoOperacionCobTab2 === CONSTANTES.SEPARADOR ||
        this.state.tipoOperacionCobTab2 === "") &&
      this.state.tipoOperacionTab2.split(CONSTANTES.SEPARADOR)[0] !=
        "PAGO_EN_LINEA" &&
      this.state.tipoTab2.split(CONSTANTES.SEPARADOR)[0] == "1"
    ) {
      console.log("error tipoOperacionCob");
      return 0;
    } else if (
      this.state.tipoTab2.split(CONSTANTES.SEPARADOR)[0] != "2" &&
      this.state.polizaTab2 === ""
    ) {
      console.log("error poliza");
      return 0;
    } else if (this.state.codigoProductoTab2 === "") {
      console.log("error codigo producto");
      return 0;
    } else if (!update && this.state.emailClienteTab2 === "") {
      console.log("error emailCliente");
      return 0;
    } else if (!update && !regExp.test(this.state.emailClienteTab2)) {
      console.log("error emailCliente");
      return 0;
    } else if (!update && this.state.total === "") {
      console.log("error total");
      return 0;
    } else if (
      this.state.monedaTab2 === CONSTANTES.SEPARADOR ||
      this.state.monedaTab2 === ""
    ) {
      console.log("error moneda");
      return 0;
    } else if (
      this.state.tipoTab2.split(CONSTANTES.SEPARADOR)[0] != "2" &&
      this.state.documento === "" &&
      this.state.productoTab2.split(CONSTANTES.SEPARADOR)[0] != "VIDA"
    ) {
      console.log("error documento");
      return 0;
    }

    if (
      this.state.tipoOperacionCobTab2.split(CONSTANTES.SEPARADOR)[0] ===
        "FIN" &&
      this.state.numCuotasTab2.split(CONSTANTES.SEPARADOR)[0] === ""
    ) {
      console.log("error numCuotas");
      return 0;
    }
    if (
      (this.state.numIdTercero == null ||
        this.state.numIdTercero == undefined ||
        this.state.numIdTercero == "" ||
        this.state.numIdTercero == "0" ||
        this.state.numIdTercero == "null") &&
      this.state.tipoOperacionTab2.split(CONSTANTES.SEPARADOR)[0] !=
        "PAGO_EN_LINEA"
    ) {
      this.mostrarModal(
        "mensaje",
        "Operacion no permitida para el cliente, solo puede realizar pago en linea"
      );
      return 0;
    }
    //Validaciones flexivida
    if (this.state.codigoProductoTab2 == CONSTANTES.CODE_FLEXIVIDA) {
      if(!LISTA_TIPO_OPERACIONES_FLEXIVIDA.find((option) => option.id == this.state.tipoOperacionTab2.split(CONSTANTES.SEPARADOR)[0])){
        this.mostrarModal(
          "mensaje",
          "Operación no permitida para el producto, debe realizar por separado primero pago en línea y luego afiliación"
        );
        return 0;
      }
      //Ini - CRS-6696
      if ( this.state.documento === "" && this.state.tipoTab2.split(CONSTANTES.SEPARADOR)[0] == "1"){        
        this.mostrarModal(
          "mensaje",
          `Para los productos Flexi Vida, es necesario seleccionar en Ver documentos de Pago.`
        );
        return 0;
      }
      //Fin - CRS-6696
      if (this.state.tipoOperacionTab2.split(CONSTANTES.SEPARADOR)[0] == "PAGO_EN_LINEA" &&
        this.state.documentoMonto!="" && this.state.total < this.state.documentoMonto){
        const currency = this.state.listaMoneda.find(item => item.id === this.state.monedaTab2);
        this.mostrarModal(
          "mensaje",
          `Para este producto, el monto debe ser igual o mayor a la deuda del documento seleccionado: ${currency.symbol} ${this.state.documentoMonto}`
        );
        return 0;
      }
    }
    //Fin validaciones flexivida
    // validar si this.state.numIdTercero == null y estado es suscripcion y pago suscripcion entonces la operacción no permitida
    return 1;
  };

  mostrarModal = (casoModal, m_modal) => {
    this.setState({
      casoModal,
      m_modal,
      mostrarModal: true,
    });
  };

  mostrarModalDocumentosPago = (casoModal, m_modal) => {
    this.setState({
      casoModal,
      m_modal,
      mostrarDocumentosPago: true,
    });
  };

  limpiarPreResultado = () => {
    this.setState({
      aseguradoNombre: "",
      aseguradoApellidoPat: "",
      aseguradoApellidoMat: "",
      tipoOperacionCobTab1: "",
      tipoOperacionCobTab2: "",
      //Ini - M.315456.01
      //tipoOperacionTab1: "",
      //Fin - M.315456.01
      tipoOperacionTab2: "",
      producto: "",
      codigoProductoTab1: "",
      codigoProductoTab2: "",
      polizaTab1: "",
      //Ini - M.315456.01
      certificadoTab1: "",
      showCertificadoTab1: false,
      //Fin - M.315456.01
      polizaTab2: "",
      //Ini - M.315456.01
      //emailClienteTab1: "",
      //Fin - M.315456.01
      emailClienteTab2: "",
      emailAsesor: "",
      moneda: "PEN",
      monedaTab1: "PEN",
      monedaTab2: "PEN",
      total: "",
      totalTemp: "",
      numIdTercero: "",
      showDocumentoCobro: "None",
      activeCodProducto: false,
      activePoliza: false,
      disabledCodProducto: false,
      disabledNumPoliza: false,
      disabledMoneda: false,
      documento: "",
      documentos: "",
      documentoMonto: "",
      fecVenDoc: "",
      tipoDocumentoCob: "",
      certificado: "",
    });
    this.state.listaMoneda.map((obj) => (obj.selected = false));
  };

  limpiarBusqueda = () => {
    this.props.mostrarLoading();
    this.setState({
      nroDocumento: "",
      showBusqueda: "None",
      aseguradoNombre: "",
      aseguradoApellidoPat: "",
      aseguradoApellidoMat: "",
      tipoDocumento: "",
      tipoOperacionCobTab1: "",
      tipoOperacionCobTab2: "",
      //Ini - M.315456.01
      //tipoOperacionTab1: "",
      //Fin - M.315456.01
      tipoOperacionTab2: "",
      producto: "",
      productoTab1: "",
      productoTab2: "",
      codigoProductoTab1: "",
      codigoProductoTab2: "",
      polizaTab1: "",
      //Ini - M.315456.01
      certificadoTab1: "",
      showCertificadoTab1: false,
      //Fin - M.315456.01
      polizaTab2: "",
      numCuotasTab1: "",
      numCuotasTab2: "",
      //emailCliente: '',
      //Ini - M.315456.01
      //emailClienteTab1: "",
      //Fin - M.315456.01
      emailClienteTab2: "",
      emailAsesor: "",
      moneda: "PEN",
      monedaTab1: "",
      monedaTab2: "",
      total: "",
      totalTemp: "",
      numIdTercero: "",
      disabledNumdoc: false,
      disabledTipoDoc: false,
      disabledMonto: false,
      disabledOpCob: false,
      documentoCobro: "",
      showDocumentoCobro: "None",
      activeCodProducto: false,
      activePoliza: false,
      disabledCodProducto: false,
      disabledNumPoliza: false,
      disabledMoneda: false,
      documento: "",
      documentos: "",
      documentoMonto: "",
      fecVenDoc: "",
      tipoDocumentoCob: "",
      tipoTab1: "",
      tipoTab2: "",
      name_moneda: "",
      name_productoTab2: "",
      name_tipo: "",
      name_tipoOperacionTab2: "",
      emailClienteTab2: "",
      tipoDocumento: "",

      productoTab1Error: false,
      tipoOperacionCobTab1Error: false,
      //Ini - M.315456.01
      //tipoOperacionTab1Error: false,
      //Fin - M.315456.01
      codigoProductoTab1Error: false,
      polizaTab1Error: false,
      //Ini - M.315456.01
      certificadoTab1Error: false,      
      //emailClienteTab1Error: false,
      //Fin - M.315456.01
      numCuotasTab1Error: false,
      monedaTab1Error: false,
      tipoTab2Error: false,
      productoTab2Error: false,
      tipoOperacionTab2Error: false,
      tipoOperacionCobTab2Error: false,
      monedaTab2Error: false,
      codigoProductoTab2Error: false,
      totalError: false,
      polizaTab2Error: false,
      emailClienteTab2Error: false,
      numCuotasTab2Error: false,
      certificado: "",
    });
    this.state.listaMoneda.map((obj) => (obj.selected = false));
    this.props.ocultarLoading();
  };

  limpiarCambioTipoTab1 = () => {
    this.setState({
      tipoOperacionCobTab1: "",
      //Ini - M.315456.01
      //tipoOperacionTab1: "",
      //Fin - M.315456.01
      codigoProductoTab1: "",
      polizaTab1: "",
      //Ini - M.315456.01
      certificadoTab1: "",
      showCertificadoTab1: false,
      //Fin - M.315456.01
      numCuotasTab1: "",
      monedaTab1: "",
      documento: "",
      documentos: "",
      documentoMonto:"",
      fecVenDoc: "",
      listaOperacion1: this.state.listaOperacion1,
      listaMoneda1: this.state.listaMoneda,
      listaCuotasTab1: this.state.listaCuotas,
      //Ini - M.315456.01
      //selectedItemTipoOperacionTab1: "",
      //Fin - M.315456.01
      selectedItemTipoOperacionCobTab1: "",
      selectedItemMonedaTab1: "",
      selectedItemNumCuotasTab1: "",
      //Ini - M.315456.01
      //tipoOperacionTab1Error: false,
      //Fin - M.315456.01
      tipoOperacionCobTab1Error: false,
      polizaTab1Error: false,
      //Ini - M.315456.01
      certificadoTab1Error: false,      
      //emailClienteTab1Error: false,
      //Fin - M.315456.01
      codigoProductoTab1Error: false,
      monedaTab1Error: false,
      certificado: "",
    });
    this.state.listaMoneda1.map((obj) => (obj.selected = false));
  };

  limpiarCambioTipoTab2 = () => {
    this.setState({
      tipoOperacionCobTab2: "",
      tipoOperacionTab2: "",
      codigoProductoTab2: "",
      polizaTab2: "",
      numCuotasTab2: "",
      monedaTab2: "",
      total: "",
      totalTemp: "",
      showDocumentoCobro: "None",
      activeCodProducto: false,
      activePoliza: false,
      disabledCodProducto: false,
      disabledNumPoliza: false,
      disabledMoneda: false,
      documento: "",
      documentos: "",
      documentoMonto:"",
      fecVenDoc: "",
      tipoDocumentoCob: "",
      listaOperacion2: this.state.listaOperacion2,
      listaMoneda2: this.state.listaMoneda,
      listaCuotasTab2: this.state.listaCuotas,
      selectedItemTipoOperacionTab2: "",
      selectedItemTipoOperacionCobTab2: "",
      selectedItemMonedaTab2: "",
      selectedItemNumCuotasTab2: "",
      tipoTab2Error: false,
      productoTab2Error: false,
      tipoOperacionTab2Error: false,
      tipoOperacionCobTab2Error: false,
      codigoProductoTab2Error: false,
      polizaTab2Error: false,
      emailClienteTab2Error: false,
      monedaTab2Error: false,
      totalError: false,
      numCuotasTab2Error: false,
      certificado: "",
    });
    this.state.listaMoneda2.map((obj) => (obj.selected = false));
  };

  onSelect = (sel) => {
    let monto = 0
    this.setState({
      listaOperacion2: LISTA_TIPO_OPERACIONES,
    });
    this.onChange({
      target: { name: "codigoProductoTab2", value: sel[0].codProducto },
    });
    this.onChange({ target: { name: "polizaTab2", value: sel[0].numPoliza } });
    this.onChangeMoneda2({ id: String(sel[0].moneda) });
    for (let index = 0; index < this.state.listaMoneda.length; index++) {
      if (this.state.listaMoneda[index].id == sel[0].moneda) {
        this.state.listaMoneda[index].selected = true;
      } else {
        this.state.listaMoneda[index].selected = false;
      }
    }

    for (let index = 0; index < sel.length; index++) {
      monto = monto + sel[index].monto;
    }

    let fecVenDoc = sel.map(item => {return {fecVenc: item.fecVenc, documento:item.numDocumento}})
    let documentos = sel.map(item => {return {monto: item.monto, documentoCobro:item.numDocumento}})

    this.setState({
      activeCodProducto: true,
      activePoliza: true,
      disabledCodProducto: true,
      disabledNumPoliza: true,
      disabledMoneda: true,
      documentoCobroError: false,
      documento: sel[0].numDocumento,
      documentos: documentos,
      documentoMonto: sel[0].monto,
      fecVenDoc: fecVenDoc,
      tipoDocumentoCob: sel[0].tipoDocumento,
      total: String(monto.toFixed(2)),
      totalError: false,
      totalTemp: String(monto.toFixed(2)),
      disabledMonto: true,
      certificado: sel[0].certificado,
    });

    this.setState({
      selectedItemTipoOperacionCobTab2: "",
      tipoOperacionCobTab2: "",
      name_tipoOperacionCobTab2: "",
      tipoOperacionTab2: "",
      name_tipoOperacionTab2: "",
      selectedItemTipoOperacionTab2: ""
    });
  };

  ObtenerUltDocPoliza = (listaDocu) => {
    var polizas = {};
    listaDocu = listaDocu.filter((obj) => {
      if (polizas[obj.codProducto + "-" + obj.numPoliza]) {
        polizas[obj.codProducto + "-" + obj.numPoliza]++;
          obj.index = polizas[obj.codProducto + "-" + obj.numPoliza];
          return true;
      } else {
        polizas[obj.codProducto + "-" + obj.numPoliza] = 1;
        obj.index = 1;
        return true;
      }
    });
    this.state.polizas = polizas;
    return listaDocu;
  };

  render() {
    const productos = [];
    return (
      <section
        className={
          this.state.showMetpagos
            ? "showMetpagos container-fluid container-filtercolor"
            : "container-fluid container-filtercolor"
        }
      >
        <div className="container container-filter d-flex justify-content-start mb-flex-column">
          <div className="container-filter-info d-flex justify-content-start mb-full">
            <div className="filter-info-body">
              <Breadcrumb />
              <h1>
                <b>Consulta, </b>afiliación y pago
              </h1>
              {this.state.showMetpagos ? (
                // true?(
                <span className="labelfiltro d-flex align-items-center">
                  <a
                    className="d-flex align-items-center"
                    onClick={this.backMetpagos}
                    href="#"
                  >
                    <img src={circleleft} alt="" />
                  </a>
                  Resultados de búsqueda
                </span>
              ) : (
                <p>
                  Visualiza los productos asociados a los documentos de los
                  clientes.
                </p>
              )}
            </div>
          </div>

          <div className="container-filter-filter d-flex justify-content-start flex-grow-1 mb-full">
            <div className="filter-filter-body">
              <label className="label">
                Edita los datos para realizar la búsqueda
              </label>

              <div className="bx-document d-flex">
                <select
                  id="tipoDocumento"
                  name="tipoDocumento"
                  onChange={(e) => this.handleChange(e)}
                >
                  <option value="2">DNI</option>
                  <option value="4">C.E.</option>
                  <option value="6">PASAPORTE</option>
                </select>
                <div className="input-field col s12">
                  <input
                    id="nroDocumento"
                    type="text"
                    className="validate"
                    value={this.state.nroDocumento}
                    name="nroDocumento"
                    maxLength={this.state.inputMax}
                    onChange={(e) => this.handleChange(e)}
                  />
                  <label htmlFor="nroDocumento">Nro. de Documento</label>
                </div>
              </div>

              <a
                onClick={this.buscarTercero}
                disabled={this.state.inputValid}
                className="btn-rimac waves-effect waves-light btn"
              >
                COMENCEMOS
              </a>
            </div>
          </div>
        </div>

        {this.state.showMetpagos ? (
          <div className="container-fluid bwhite">
            <div className="container container-metpagos">
              <div className="container-metpagos-left">
                {!this.state.successafil ? (
                  <>
                    <img
                      className="metpagos-left-detail-img"
                      src={personajes}
                      alt=""
                    />
                    <span className="metpagos-left-detail-title">
                      Datos del cliente
                    </span>
                    <div className="metpagos-left-detail-list">
                      <span>
                        <b>Nombre: </b>
                        {this.state.aseguradoNombre.charAt(0).toUpperCase() +
                          this.state.aseguradoNombre.slice(1)}
                      </span>
                      <span>
                        <b>Apellido Paterno: </b>
                        {this.state.aseguradoApellidoPat}
                      </span>
                      <span>
                        <b>Apellido Materno: </b>
                        {this.state.aseguradoApellidoMat}
                      </span>
                      <span>
                        <b>{this.state.textTipoDocumento}: </b>
                        {this.state.nroDocumento}
                      </span>
                    </div>
                  </>
                ) : (
                  <div>
                    <img
                      className="metpagos-left-detail-img-typ"
                      src={personajestyp}
                      alt=""
                    />
                  </div>
                )}
              </div>

              <div className="container-metpagos-right">
                <div className="container container-metpagos-body">
                  {!this.state.successafil ? (
                    <div>
                      <div className="metpagos-body-tabs">
                      {Object.values(localStorage.getItem("permisos") ? JSON.parse(localStorage.getItem("permisos")) : "").map((p,key) => {
                            if(p.path === '/metodospago'){
                                if(p.acciones.tarjeta_existente === "true"){
                                    return(<a id="tab1" className="tabIndex" onClick={(e) => this.handleTab(e)}>Tarjeta existente</a>)                                    
                                }
                                else
                                {
                                    return null;
                                }
                            }
                            else
                            {
                                return null;
                            }
                          })
                        } 
                        {Object.values(localStorage.getItem("permisos") ? JSON.parse(localStorage.getItem("permisos")) : "").map((p,key) => {
                            if(p.path === '/metodospago'){
                                if(p.acciones.agregar_tarjeta === "true"){
                                    return(<a id="tab2" className="tabIndex active" onClick={(e) => this.handleTab(e)}>Agregar tarjeta</a>)                                    
                                }
                                else
                                {
                                    return null;
                                }
                            }
                            else
                            {
                                return null;
                            }
                          })
                        } 
                        {/*
                        <a
                          id="tab1"
                          className="tabIndex"
                          onClick={(e) => this.handleTab(e)}
                        >
                          Tarjeta existente
                        </a>

                        <a
                          id="tab2"
                          className="tabIndex active"
                          onClick={(e) => this.handleTab(e)}
                        >
                          Agregar tarjeta
                        </a>
                        */}


                      </div>

                      <div className="tab-content tab1">
                        {this.state.nextafiliacion ? (
                          <div>
                            <p className="metpagos-body-tabs-subtitle">
                              Completa los datos para poder finalizar
                            </p>

                            <div className="metpagos-body-form d-flex flex-wrap justify-content-between">
                              <div
                                className={
                                  this.state.productoTab1Error
                                    ? "border-error cont-dropdown inputSelect-mid"
                                    : "cont-dropdown inputSelect-mid"
                                }
                              >
                                <CustomDropDown
                                  items={this.state.listaProducto}
                                  placeholder="Producto"
                                  optionClicked={(e) => {
                                    this.onChangeProductoTab1(e);
                                  }}
                                />
                                <span className="show-error">
                                  {this.state.productoTab1Error
                                    ? "*Seleccione Producto"
                                    : ""}
                                </span>
                              </div>

                              <div
                                className={
                                  this.state.tipoOperacionCobTab1Error
                                    ? "border-error cont-dropdown inputSelect-mid"
                                    : "cont-dropdown inputSelect-mid"
                                }
                              >
                                <CustomDropDown
                                  items={this.state.listaOperacionCob}
                                  placeholder="Operación Cob."
                                  optionClicked={(e) => {
                                    this.onChangeOperacionCobTab1(e);
                                  }}
                                  selectedItem={
                                    this.state.selectedItemTipoOperacionCobTab1
                                  }
                                />
                                <span className="show-error">
                                  {this.state.tipoOperacionCobTab1Error
                                    ? "*Seleccione Operación Cobranza"
                                    : ""}
                                </span>
                              </div>

                              {/* 
                              Ini - M.315456.01
                              <div
                                className={
                                  this.state.tipoOperacionTab1Error
                                    ? "border-error cont-dropdown inputSelect-mid"
                                    : "cont-dropdown inputSelect-mid"
                                }
                              >
                                <CustomDropDown
                                  items={this.state.listaOperacion1}
                                  placeholder="Operación"
                                  optionClicked={(e) => {
                                    this.onChangeOperacionTab1(e);
                                  }}
                                  selectedItem={
                                    this.state.selectedItemTipoOperacionTab1
                                  }
                                />
                                <span className="show-error">
                                  {this.state.tipoOperacionTab1Error
                                    ? "*Seleccione tipo de Operación"
                                    : ""}
                                </span>
                              </div> 
                              Fin - M.315456.01
                              */}

                              <div
                                className={
                                  this.state.codigoProductoTab1Error
                                    ? "border-error inputbox inputbox-mid input-field"
                                    : "inputbox inputbox-mid input-field"
                                }
                              >
                                <input
                                  id="codigoProductoTab1"
                                  type="text"
                                  className="validate"
                                  name="codigoProductoTab1"
                                  value={this.state.codigoProductoTab1}
                                  onChange={this.onChange}
                                />
                                <label for="codigoProductoTab1">
                                  Cod. de producto
                                </label>
                                {this.state.codigoProductoTab1Error ? (
                                  <span className="labelError">
                                    *Ingrese un código de producto
                                  </span>
                                ) : null}
                              </div>

                              <div
                                className={
                                  this.state.polizaTab1Error
                                  ? "border-error inputbox inputbox-mid input-field"
                                  : "inputbox inputbox-mid input-field"
                                }
                              >
                                <input
                                  id="polizaTab1"
                                  type="text"
                                  className="validate"
                                  name="polizaTab1"
                                  value={this.state.polizaTab1}
                                  onChange={this.onChange}
                                />
                                <label for="polizaTab1">Número de póliza</label>
                                {this.state.polizaTab1Error ? (
                                  <span className="labelError">
                                    *Ingrese un número de Poliza
                                  </span>
                                ) : null}
                              </div>
                              {
                              //Ini - M.315456.01  
                              }
                              <div                               
                                className={
                                  this.state.certificadoTab1Error?"border-error inputbox inputbox-mid input-field": this.state.showCertificadoTab1?"inputbox inputbox-mid input-field": "hidden"                                                 
                                }                                                               
                              >
                                <input
                                  id="certificadoTab1"
                                  type={this.state.showCertificadoTab1?"number": "hidden"}
                                  className="validate"
                                  name="certificadoTab1"
                                  value={this.state.certificadoTab1}
                                  onChange={this.onChange}
                                />
                                <label for="certificadoTab1" class={this.state.showCertificadoTab1?"": "hidden"}>Número de certificado</label>
                                {
                                this.state.certificadoTab1Error ? (
                                  <span className="labelError">
                                    *Ingrese un número de certificado
                                  </span>
                                ) : null
                                }
                              </div>
                              
                              {
                              /* 
                              Ini - M.315456.01  
                              <div
                                className={
                                  this.state.emailClienteTab1Error
                                    ? "border-error inputbox input-field"
                                    : "inputbox input-field"
                                }
                              >                               
                                <input
                                  id="emailClienteTab1"
                                  name="emailClienteTab1"
                                  type="email"
                                  className="validate"
                                  name="emailClienteTab1"
                                  value={this.state.emailClienteTab1}
                                  onChange={this.onChange}
                                />                                
                                <label
                                  for="emailClienteTab1"
                                  className={
                                    this.state.emailClienteTab1 ? "active" : ""
                                  }
                                >
                                  Email cliente
                                </label>
                                {this.state.emailClienteTab1Error ? (
                                  <span className="labelError">
                                    *Ingrese un Email de cliente Válido
                                  </span>
                                ) : null}
                              </div> 
                              Fin - M.315456.01
                              */
                              }                            

                              <div
                                className={
                                  this.state.numCuotasTab1Error
                                    ? "border-error cont-dropdown inputSelect-mid selectcuotas"
                                    : "cont-dropdown inputSelect-mid selectcuotas"
                                }
                              >
                                <CustomDropDown
                                  items={this.state.listaCuotas}
                                  placeholder="Cuotas"
                                  disabled={this.state.disabledCuotaTab1}
                                  optionClicked={(e) => {
                                    this.onChangeListaCuotasTab1(e);
                                  }}
                                  selectedItem={
                                    this.state.selectedItemNumCuotasTab1
                                  }
                                />
                                <span className="show-error">
                                  {this.state.numCuotasTab1Error
                                    ? "*Seleccione el número de cuotas"
                                    : ""}
                                </span>
                              </div>

                              {
                              //Ini - M.315456.01
                              }
                              {/* <div
                              className={this.state.showCertificadoTab1?"hidden":"inputbox inputbox-mid input-field"}                                
                              >                                
                              </div>                                                                   */}
                              {
                              //Fin - M.315456.01
                              }
                              <div
                                className={
                                  this.state.monedaTab1Error
                                    ? "border-error cont-dropdown inputSelect-mid"
                                    : "cont-dropdown inputSelect-mid"
                                }
                              >
                                <CustomDropDown
                                  items={this.state.listaMoneda}
                                  placeholder="Tipo de moneda"
                                  optionClicked={(e) => {
                                    this.onChangeMonedaTab1(e);
                                  }}
                                  selectedItem={
                                    this.state.selectedItemMonedaTab1
                                  }
                                />
                                <span className="show-error">
                                  {this.state.monedaTab1Error
                                    ? "*Seleccione un tipo de moneda"
                                    : ""}
                                </span>
                              </div> 
                              {
                              //Ini - M.315456.01
                              }
                              <div
                              className={this.state.showCertificadoTab1?"inputbox inputbox-mid input-field":"hidden"}                                
                              >                                
                              </div>                                                                  
                              {
                              //Fin - M.315456.01
                              }
                              <div>
                              <a
                                onClick={this.handleAfiliacion}
                                disabled={this.state.inputValid}
                                className="btn-rimac waves-effect waves-light btn"
                              >
                                SOLICITAR AFILIACIÓN
                              </a>
                            </div>

                            </div>
                          </div>
                        ) : (
                          <div>
                            <p className="metpagos-body-tabs-subtitle">
                              {!this.state.metpagosLoader &&
                              !this.state.payments
                                ? "Este cliente no tiene métodos de pago registrados en nuestro sistema"
                                : "Seleccione una opción para afiliar a una póliza"}
                            </p>
                            <div className="metpagos-body-content d-flex flex-wrap justify-content-between">
                              {this.state.payments ? (
                                this.state.payments.map((item, index) => {
                                  return (
                                    <div
                                      id={"bx" + index}
                                      className="bxmetpago"
                                      onClick={() =>
                                        this.selectCard(item, index)
                                      }
                                    >
                                      <div
                                        id={"check" + index}
                                        className="bordericon"
                                      >
                                        <div className="iconcheck"></div>
                                      </div>
                                      <i>ACTIVO</i>
                                      <p>{item.nombreTitular}</p>
                                      <b>
                                        Nº Pago Fácil: {item.numeroPagoFacil}
                                      </b>
                                      <span>
                                        <img
                                          src={
                                            item.codigoTarjeta == "VISA"
                                              ? ccardVisa
                                              : item.codigoTarjeta == "DINN"
                                              ? ccardDinner
                                              : item.codigoTarjeta == "AMEX"
                                              ? ccardAmex
                                              : item.codigoTarjeta == "MCAR"
                                              ? ccardMaster
                                              : ""
                                          }
                                          alt=""
                                        />{" "}
                                        {item.codigoTarjeta === "VISA"
                                          ? "Visa"
                                          : item.codigoTarjeta === "DINN"
                                          ? "Diners"
                                          : item.codigoTarjeta === "AMEX"
                                          ? "Amex"
                                          : item.codigoTarjeta === "MCAR"
                                          ? "Master"
                                          : ""}{" "}
                                        {item.numeroTarjeta}
                                      </span>
                                      <hr />
                                      <div className="detail">
                                        <span>VÍA COBRO - TIPO VÍA COBRO</span>
                                        <p>
                                          {item.entidadFinanciera} -{" "}
                                          {item.tipoViaCobro}
                                        </p>
                                      </div>
                                      <div className="detail">
                                        <span>PRODUCTOS ASOCIADOS</span>
                                        <p className="detail-products d-flex">
                                          {item.productos.map((item) => {
                                            return (
                                              <p className="d-flex">
                                                {item.nombreProducto}
                                                <p className="slash">
                                                  {" "}
                                                  {` / `}{" "}
                                                </p>
                                              </p>
                                            );
                                          })}
                                        </p>
                                      </div>
                                    </div>
                                  );
                                })
                              ) : !this.state.payments &&
                                this.state.metpagosLoader ? (
                                <>
                                  <div className="bxmetpago">
                                    <i className="data"> </i>
                                    <p className="data"> </p>
                                    <b className="data"> </b>
                                    <span className="data"> </span>
                                    <hr />
                                    <div className="detail">
                                      <span className="data"> </span>
                                      <p className="data"> </p>
                                    </div>
                                    <div className="detail">
                                      <span className="data"> </span>
                                      <p className="data"> </p>
                                    </div>
                                    <span className="data"> </span>
                                  </div>
                                  <div className="bxmetpago">
                                    <i className="data"> </i>
                                    <p className="data"> </p>
                                    <b className="data"> </b>
                                    <span className="data"> </span>
                                    <hr />
                                    <div className="detail">
                                      <span className="data"> </span>
                                      <p className="data"> </p>
                                    </div>
                                    <div className="detail">
                                      <span className="data"> </span>
                                      <p className="data"> </p>
                                    </div>
                                    <span className="data"> </span>
                                  </div>
                                </>
                              ) : (
                                <></>
                              )}
                              {!this.state.metpagosLoader &&
                              !this.state.payments ? null : (
                                <a
                                  onClick={() => this.nextafiliacion()}
                                  disabled={!this.state.cardselected}
                                  className="btn-rimac waves-effect waves-light btn"
                                >
                                  SIGUIENTE
                                </a>
                              )}
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="tab-content tab2 show">
                        <div className="metpagos-body-form ">
                          <p className="metpagos-body-tabs-subtitle">
                            Ingresa los datos solicitados. Generaremos un enlace
                            que el cliente recibirá por correo.
                          </p>

                          <div className="d-flex flex-wrap justify-content-between">
                            {/* border-error */}

                            <div
                              className={
                                this.state.companiaError
                                  ? "border-error cont-dropdown inputSelect-mid"
                                  : "cont-dropdown inputSelect-mid"
                              }
                            >
                              <CustomDropDown
                                items={this.state.listaCompania}
                                selectedItem={
                                  this.state.listaCompania.filter(
                                    (obj) => obj.selected
                                  )[0]
                                }
                                placeholder="Compañia"
                                optionClicked={(e) => {
                                  this.onChangeCompania(e);
                                }}
                              />
                              <span className="show-error">
                                {this.state.companiaError
                                  ? "*Seleccione Compañia"
                                  : ""}
                              </span>
                            </div>

                            <div
                              className={
                                this.state.tipoTab2Error
                                  ? "border-error cont-dropdown inputSelect-mid"
                                  : "cont-dropdown inputSelect-mid"
                              }
                            >
                              <CustomDropDown
                                items={this.state.listaTipo}
                                placeholder="Tipo"
                                optionClicked={(e) => {
                                  this.onChangeTipo(e);
                                }}
                              />
                              <span className="show-error">
                                {this.state.tipoTab2Error
                                  ? "*Seleccione Tipo"
                                  : ""}
                              </span>
                            </div>

                            <div
                              className={
                                this.state.productoTab2Error
                                  ? "border-error cont-dropdown inputSelect-mid"
                                  : "cont-dropdown inputSelect-mid"
                              }
                            >
                              <CustomDropDown
                                items={this.state.listaProducto}
                                placeholder="Riesgo"
                                optionClicked={(e) => {
                                  this.onChangeProductoTab2(e);
                                }}
                              />
                              <span className="show-error">
                                {this.state.productoTab2Error
                                  ? "*Seleccione Riesgo"
                                  : ""}
                              </span>
                            </div>

                            <div
                              className={
                                this.state.tipoOperacionTab2Error
                                  ? "border-error cont-dropdown inputSelect-mid"
                                  : "cont-dropdown inputSelect-mid"
                              }
                            >
                              <CustomDropDown
                                items={this.state.listaOperacion2}
                                placeholder="Operación"
                                optionClicked={(e) => {
                                  this.onChangeOperacionTab2(e);
                                }}
                                selectedItem={
                                  this.state.selectedItemTipoOperacionTab2
                                }
                              />
                              <span className="show-error">
                                {this.state.tipoOperacionTab2Error
                                  ? "*Seleccione tipo de Operación"
                                  : ""}
                              </span>
                            </div>
                            {this.state.showPolizaExistente && (
                              <>
                                <div
                                  className={
                                    this.state.documentoCobroError
                                      ? "border-error inputbox input-field"
                                      : "inputbox input-field "
                                  }
                                  style={{
                                    display: this.state.showDocumentoCobro,
                                  }}
                                >
                                  {this.state.listaDocumentoCobro.length > 0 ? (
                                    <>
                                      <div>
                                        <a
                                          onClick={
                                            this.mostrarModalDocumentosPago
                                          }
                                          className={"pointer"}
                                        >
                                          Ver documentos de Pago (
                                          {
                                            this.state.listaDocumentoCobro
                                              .length
                                          }
                                          )
                                        </a>
                                      </div>
                                      {this.state.documentoCobroError ? (
                                        <span className="labelError">
                                          Seleccione un documento de cobro
                                        </span>
                                      ) : null}
                                    </>
                                  ) : (
                                    <p>No existen documentos de Pago</p>
                                  )}
                                </div>
                                {(this.state.documento ||
                                  this.state.fecVenc) && (
                                    <div className="inputbox input-field d-flex flex-wrap justify-content-between label-documento scroll-fech-venc-doc">
                                    {this.state.fecVenDoc.map(item => {
                                      return (
                                        <>
                                          <div
                                            className={"inputbox-mid  input-field "}
                                          >
                                            <span className="text__doc-venc">
                                              <p>Documento: </p>
                                              {item.documento}
                                            </span>
                                          </div>
                                          <div
                                            className={"inputbox-mid  input-field "}
                                          >
                                            <span className="text__doc-venc">
                                              <p>Fecha Vencimiento: </p>
                                              {item.fecVenc}
                                            </span>
                                          </div>
                                        </>
                                      )
                                    })}
                                      
                                    </div>
                                )}
                                <div
                                  className={
                                    this.state.tipoOperacionCobTab2Error
                                      ? "border-error cont-dropdown inputSelect-mid"
                                      : "cont-dropdown inputSelect-mid"
                                  }
                                >
                                  <CustomDropDown
                                    items={this.state.listaOperacionCob}
                                    placeholder="Operación Cob..."
                                    disabled={this.state.disabledOpCob}
                                    optionClicked={(e) => {
                                      this.onChangeOperacionCobTab2(e);
                                    }}
                                    selectedItem={
                                      this.state
                                        .selectedItemTipoOperacionCobTab2
                                    }
                                  />
                                  <span className="show-error">
                                    {this.state.tipoOperacionCobTab2Error
                                      ? "*Seleccione Operación Cobranza"
                                      : ""}
                                  </span>
                                </div>

                                <div
                                  className={
                                    this.state.numCuotasTab2Error
                                      ? "border-error cont-dropdown inputSelect-mid selectcuotas"
                                      : "cont-dropdown inputSelect-mid selectcuotas"
                                  }
                                >
                                  <CustomDropDown
                                    items={this.state.listaCuotas}
                                    placeholder="Cuotas"
                                    disabled={this.state.disabledCuotaTab2}
                                    optionClicked={(e) => {
                                      this.onChangeListaCuotasTab2(e);
                                    }}
                                    selectedItem={
                                      this.state.selectedItemNumCuotasTab2
                                    }
                                  />
                                  <span className="show-error">
                                    {this.state.numCuotasTab2Error
                                      ? "*Seleccione el número de cuotas"
                                      : ""}
                                  </span>
                                </div>
                              </>
                            )}

                            <div
                              className={
                                this.state.codigoProductoTab2Error
                                  ? "border-error inputbox-mid input-field"
                                  : "inputbox-mid input-field"
                              }
                            >
                              <input
                                id="codigoProductoTab2"
                                type="text"
                                className="validate"
                                name="codigoProductoTab2"
                                value={this.state.codigoProductoTab2}
                                onChange={this.onChange}
                                disabled={this.state.disabledCodProducto}
                              />
                              <label
                                for="codigoProductoTab2"
                                className={
                                  this.state.activeCodProducto ? "active " : ""
                                }
                              >
                                Cod. de producto
                              </label>
                              {this.state.codigoProductoTab2Error ? (
                                <span className="labelError">
                                  *Ingrese un código de producto
                                </span>
                              ) : null}
                            </div>

                            {this.state.showNumPoliza && (
                              <div
                                className={
                                  this.state.polizaTab2Error
                                    ? "border-error inputbox-mid input-field"
                                    : "inputbox-mid input-field"
                                }
                              >
                                <input
                                  id="polizaTab2"
                                  type="text"
                                  className="validate"
                                  name="polizaTab2"
                                  value={this.state.polizaTab2}
                                  onChange={this.onChange}
                                  disabled={this.state.disabledNumPoliza}
                                />
                                <label
                                  for="polizaTab2"
                                  className={
                                    this.state.activePoliza ? "active " : ""
                                  }
                                >
                                  Número de póliza
                                </label>
                                {this.state.polizaTab2Error ? (
                                  <span className="labelError">
                                    *Ingrese un número de Poliza
                                  </span>
                                ) : null}
                              </div>
                            )}

                            <div className="inputbox input-field disabled">
                              <input
                                id="emailAsesor"
                                type="email"
                                className="validate"
                                disabled
                                name="emailAsesor"
                                value={this.state.emailAsesor}
                                onBlur={this.validarFormularioTab2}
                                onChange={this.onChange}
                              />
                              <label
                                for="emailAsesor"
                                className={
                                  this.state.emailAsesor ? "active" : ""
                                }
                              >
                                Email asesor
                              </label>
                            </div>
                            <div
                              className={
                                this.state.emailClienteTab2Error
                                  ? "border-error inputbox input-field"
                                  : "inputbox input-field"
                              }
                            >
                              <input
                                id="emailClienteTab2"
                                name="emailClienteTab2"
                                type="email"
                                className="validate"
                                value={this.state.emailClienteTab2}
                                onBlur={this.validarFormularioTab2}
                                onChange={this.onChange}
                              />
                              <label
                                for="emailClienteTab2"
                                className={
                                  this.state.emailClienteTab2 ? "active" : ""
                                }
                              >
                                Email cliente
                              </label>
                              {this.state.emailClienteTab2Error ? (
                                <span className="labelError">
                                  *Ingrese un Email de cliente Válido
                                </span>
                              ) : null}
                            </div> 
                            

                            {/*<div className={this.state.totalError?"border-error selectext selectmonto d-flex":"selectext selectmonto d-flex"}>*/}

                            <div
                              className={
                                this.state.monedaTab2Error
                                  ? "border-error cont-dropdown inputSelect-mid selectcuotas"
                                  : "cont-dropdown inputSelect-mid selectcuotas"
                              }
                            >
                              <CustomDropDown
                                items={this.state.listaMoneda}
                                placeholder="Moneda"
                                optionClicked={this.onChangeMoneda2}
                                selectedItem={
                                  this.state.listaMoneda.filter(
                                    (obj) => obj.selected
                                  )[0]
                                }
                                disabled={this.state.disabledMoneda}
                              />
                              <span className="show-error">
                                {this.state.monedaTab2Error
                                  ? "*Seleccione la moneda correcta"
                                  : ""}
                              </span>
                            </div>

                            <div
                              className={
                                this.state.totalError
                                  ? "border-error inputbox-mid input-field"
                                  : "inputbox-mid input-field"
                              }
                            >
                              <input
                                id="total"
                                type="text"
                                className="validate"
                                placeholder="0.00"
                                name="total"
                                maxLength={this.state.inputMax}
                                value={this.state.total}
                                onBlur={this.validarFormularioTab2}
                                onChange={this.onChange}
                                disabled={this.state.disabledMonto}
                              />
                              <label for="total" className={"active"}>
                                Monto
                              </label>
                              {this.state.totalError ? (
                                <span className="labelError">
                                  *Ingrese un monto válido
                                </span>
                              ) : null}
                            </div>
                            {/*</div>*/}

                            <a
                              onClick={this.enviarCorreo}
                              // disabled={this.state.disabledEnviar}
                              disabled={this.state.inputValid}
                              className="btn-rimac waves-effect waves-light btn"
                            >
                              ENVIAR CORREO
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="bxTyp">
                      <span className="titleTyp">
                        <b>¡Felicidades,</b> lo lograste!
                      </span>
                      <p className="metpagos-body-tabs-subtitle paragraph">
                        Has solicitado la afiliación con éxito
                      </p>
                      <div className="bxTyp_resume">
                        <p>DATOS DE LA TARJETA</p>
                        <div className="bxTyp_resume_data">
                          <div className="bxTyp_resume_data_left">
                            <label>Producto</label>
                            <p>{this.state.name_productoTab1}</p>

                            <label>Operación Cob.</label>
                            <p>{this.state.name_tipoOperacionCobTab1}</p>

                            <label>Operación</label>
                            <p>{
                            //Ini - M.315456.01
                            "Suscripción"
                            //this.state.name_tipoOperacionTab1
                            //Fin - M.315456.01
                            }</p>
                          </div>
                          <div className="bxTyp_resume_data_right">
                            <label>Cod. Producto </label>
                            <p>{this.state.codigoProductoTab1}</p>

                            <label>Número de Póliza</label>
                            <p>{this.state.polizaTab1}</p>                                                       
                            {
                              this.state.certificadoTab1 === ""?(<></>): (
                              <>
                                <label>Certificado</label>
                                <p>{this.state.certificadoTab1}</p>
                              </>
                            )                             
                            }                            

                            {this.state.numCuotasTab1 === "" ||
                            this.state.numCuotasTab1 === "||" ? (
                              <></>
                            ) : (
                              <>
                                <label>Cuotas</label>
                                <p>{this.state.numCuotasTab1}</p>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                      <a
                        onClick={this.backMetpagos}
                        className="btn-rimac waves-effect waves-light btn"
                      >
                        VOLVER A CONSULTAR
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : null}
        {/* <Modal /> */}
        <ModalGenerico
          caso={this.state.casoModal}
          mostrar={this.state.mostrarModal}
          mensaje={this.state.m_modal}
          cerrarModal={() => this.setState({ mostrarModal: false })}
        />
        <DocumentosPago
          mostrar={this.state.mostrarDocumentosPago}
          mensaje={this.ObtenerUltDocPoliza(this.state.listaDocumentoCobro)}
          riesgo={
            this.state.productoTab2 &&
            this.state.listaProducto.filter(
              (obj) => obj.id == this.state.productoTab2
            )[0].text
          }
          onSelect={this.onSelect}
          documentoSelected={this.state.documentos}
          cerrarModal={() => this.setState({ mostrarDocumentosPago: false })}
          polizas={this.state.polizas}
          producto={this.state.productoTab2}
        />
      </section>
    );
  }
}
export default HOC(MetodosPago);
